import React, { createContext, useEffect, useState } from 'react'
import { getDeliveriesRealTime } from '../firebase/obj/user';


export const MapContext = createContext()

const Provider = ({ children }) => {
    const [deliveryLocations, setDeliveryLocations] = useState([])
    const [unsubscribeDeliveries, setUnsubscribeDeliveries] = useState(null)

    const listenToDeliveries = (listen) => {
        if (listen) {
            const unsubscribe = getDeliveriesRealTime(setDeliveryLocations);
            setUnsubscribeDeliveries(() => unsubscribe);
        } else {
            if (unsubscribeDeliveries) {
                unsubscribeDeliveries();
                setUnsubscribeDeliveries(null);
            }
            setDeliveryLocations([]);
        }
    };

    const value = {
        deliveryLocations,
        listenToDeliveries
    }

    return (
        <MapContext.Provider value={value}>
            {children}
        </MapContext.Provider>
    )
}

const context = {
    Provider,
    Consumer: MapContext.Consumer
}

export default context